import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DisableControlDirective } from './disable-control.directive';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

@NgModule({
  declarations: [DisableControlDirective],
  imports: [CommonModule, FormsModule, ReactiveFormsModule],
  exports: [DisableControlDirective],
})
export class DisableControlModule {}
